<div *ngIf="fromGuard" class="card error-card align-items-center mb-3">
  Existen adendas pendientes por firmar para el/los ciclo(s) escolar(es)
  {{ administrativeRule.cycle }}.
</div>

<div class="col-12">
  <div class="student-detail k-mb-10">
    <dl>
      <div>
        <dt>Matrícula:</dt>
        <dd>
          {{ administrativeRule.enrollmentNumber }}
        </dd>
      </div>
      <div>
        <dt>Alumno:</dt>
        <dd>
          {{ administrativeRule.name || "" }}
          {{ administrativeRule.lastName || "" }}
          {{ administrativeRule.secondLastName || "" }}
        </dd>
      </div>

      <ng-container>
        <div>
          <dt>Ciclo:</dt>
          <dd>
            {{ administrativeRule.cycle }}
          </dd>
        </div>
      </ng-container>
    </dl>
    <div class="icon-container">
      <i class="ph ph-user-circle"></i>
    </div>
  </div>
</div>

<form [formGroup]="form">
  <div class="co-12" formArrayName="addendums">
    <div
      class="agreements mt-5"
      *ngFor="let addendumForm of addendumsFormArray.controls; let i = index"
      [formGroupName]="i"
    >
      <div class="title">
        <p
          [ngClass]="
            displayCheckboxError('chargeback_addendum', i) ? 'required' : ''
          "
        >
          Estoy de Acuerdo y Acepto
          <a (click)="showDocument(addendums[i])">{{
            addendums[i].administrativeRuleAddendumDescription
          }}</a>
          <kendo-formerror
            *ngIf="addendumForm.get('chargeback_addendum')?.touched && addendumForm.get('chargeback_addendum')?.errors?.['required']"
          >
            Este campo es requerido.
          </kendo-formerror>
        </p>
        <input
          style="margin-right: 16px"
          formControlName="chargeback_addendum"
          type="checkbox"
          kendoCheckBox
        />
      </div>
    </div>
  </div>
</form>

<kendo-dialog-actions layout="end">
  <button (click)="closeDialog()" kendoButton>
    {{ "BUTTON.CANCEL_LABEL" | translate }}
  </button>
  <button
    (click)="acceptAddendum()"
    kendoButton
    themeColor="primary"
    [disabled]="(loading$ | async) === true"
  >
    CONFIRMAR
  </button>
</kendo-dialog-actions>
